module.exports = __webpack_public_path__ + "static/media/voucher.f02aef2c.png";